import React, { useContext, useState } from "react";
import {
  AppContext,
  toggleActiveStepByIndex,
} from "../../../provider/AppProvider";
import { wp_ajax } from "../../../../../../wp";
import { ProductContext, ModuleContext } from "../provider";
import ff from "../../../util/fabric";

interface ProductControlsProps {
  preview?: () => void;
}

function ProductControls({ preview }: ProductControlsProps): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  const {
    productPreview,
    setProductPreview,
    setIsLoading,
    isOrderFinished,
    setIsOrderFinished,
  } = useContext(AppContext);
  const { isExtraProductSelected, productType } = useContext(ProductContext);
  const { moduleInfo, areGridLinesEnabled } = useContext(ModuleContext);

  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);

  function handleAddProductToCart() {
    setIsLoading(true);
    let data: any = {
      productId: window.INITIAL_DATA.postId,
      paperPdfLink: productPreview.pdf,
      paperJpgLink: productPreview.jpg,
      projectTitle: moduleInfo.title,
    };
    if (isExtraProductSelected) {
      data = {
        ...data,
        isExtraProductChecked: isExtraProductSelected,
      };
    }
    wp_ajax("custom_add_to_cart")
      .post({ ...data })
      .then((r) => {
        if (r.status === 200) {
          if (r.data.message && r.data.message.length) {
            setRedirectUrl(r.data.redirect);
            setIsOrderFinished(true);
            r.data.message.map((m) => {
              window.globalToast({
                title: t.success,
                description: m,
              });
            });
            updateProductNumber(r.data.cartData.items);
            updateProductPrice(r.data.cartData.total);
            window.scrollTo(0, 1);
          }
        } else {
          window.globalToast({
            type: "error",
            title: t.error,
            description: t.something_went_wrong,
          });
        }
      })
      .catch((e) => {
        window.globalToast({
          title: t.error,
          description: t.something_went_wrong,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function updateProductPrice(element) {
    let header = window
      // @ts-ignore
      .jQuery(document)
      .find(".desktop-header__cart");
    window
      // @ts-ignore
      .jQuery(header[0])
      .find(".value")
      .html(element);
  }

  function updateProductNumber(items: number) {
    let actualNumber = parseInt(
      window
        // @ts-ignore
        .jQuery(document)
        .find(".desktop-header__cart")
        .find(".cart-items")
        .html() as string
    );
    window
      // @ts-ignore
      .jQuery(document)
      .find(".mobile-header__cart")
      .find(".cart-items")
      .html(`${items}`);
    window
      // @ts-ignore
      .jQuery(document)
      .find(".desktop-header__cart")
      .find(".cart-items")
      .html(`${items}`);
  }

  function handlePreview() {
    // if (moduleInfo.title) {
      if (preview) preview();
      toggleActiveStepByIndex(2);
    // } else {
    //   window.globalToast({
    //     type: "warning",
    //     title: t.warning,
    //     description: t.set_title_to_continue,
    //   });
    //   window.scrollTo(0, 1);
    // }
  }

  function handleBackAction() {
    toggleActiveStepByIndex(1);
    if (productPreview) {
      setProductPreview(null);
    } else {
      window.history.back();
    }
    // remove grid lines if user goes back from preview
    if (areGridLinesEnabled) {
      // @ts-ignore
      ff.handleLinesForImageGrid(canvasRef.current, false);
    }
  }

  function handleStartOverAction() {
    window.history.back();
    setRedirectUrl(null);
    setIsOrderFinished(false);
  }

  return (
    <div className={"d-flex flex-column"}>
      <div id={"extra-product-container"}></div>
      <div className={"d-flex justify-content-end mt-3 px-2"}>
        {isOrderFinished ? (
          <button
            className={"btn btn-light ml-3"}
            onClick={handleStartOverAction}>
            {`${window.INITIAL_DATA.TRANSLATIONS.start_over}`}
          </button>
        ) : (
          <button className={"btn btn-light ml-3"} onClick={handleBackAction}>
            {`${window.INITIAL_DATA.TRANSLATIONS.back}`}
          </button>
        )}

        {isOrderFinished ? (
          <button
            className={"btn btn-primary ml-3"}
            onClick={() => {
              window.location.href = redirectUrl;
            }}>
            {`${window.INITIAL_DATA.TRANSLATIONS.go_to_cart}`}
          </button>
        ) : productPreview ? (
          <button
            className={"btn btn-primary ml-3"}
            onClick={handleAddProductToCart}>
            {`${window.INITIAL_DATA.TRANSLATIONS.add_to_cart}`}{" "}
          </button>
        ) : (
          <button className={"btn btn-primary ml-3"} onClick={handlePreview}>
            {`${window.INITIAL_DATA.TRANSLATIONS.preview}`}
          </button>
        )}
      </div>
    </div>
  );
}

export default ProductControls;
